var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaystack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1299 3.14709H3.93506C3.42076 3.14709 3 3.56865 3 4.08392V5.77018C3 6.28545 3.42076 6.70701 3.93506 6.70701H19.0831C19.5974 6.70701 20.0182 6.28545 20.0182 5.77018V4.08392C20.0649 3.56865 19.6441 3.14709 19.1299 3.14709ZM19.1299 12.5621H3.93506C3.42076 12.5621 3 12.9837 3 13.4989V15.1852C3 15.7005 3.42076 16.122 3.93506 16.122H19.0831C19.5974 16.122 20.0182 15.7005 20.0182 15.1852V13.4989C20.0649 12.9837 19.6441 12.5621 19.1299 12.5621ZM12.4909 17.2931H3.93506C3.42076 17.2931 3 17.7146 3 18.2299V19.9162C3 20.4314 3.42076 20.853 3.93506 20.853H12.4909C13.0052 20.853 13.426 20.4314 13.426 19.9162V18.2299C13.426 17.7146 13.0052 17.2931 12.4909 17.2931ZM20.0649 7.87804H3.93506C3.42076 7.87804 3 8.2996 3 8.81483V10.5011C3 11.0164 3.42076 11.4379 3.93506 11.4379H20.0649C20.5792 11.4379 21 11.0164 21 10.5011V8.81483C21 8.2996 20.5792 7.87804 20.0649 7.87804Z",
    fill: "#0BA4DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.7931bfc64ef2a7af84c115fbdbfcd209.svg";
export { ForwardRef as ReactComponent };